import Tracker from '@openreplay/tracker';

/**
 * OpenReplay tracker singleton. Lives in its own module (not App.tsx) so leaf
 * components (SyncStatusCard, LoginScreen, SlackMessageModal...) don't have to
 * import the ROOT App module - which drags the entire route/PWA import graph
 * (incl. the Vite-only 'virtual:pwa-register') into anything that just wants to
 * log an event, and made those components untestable under bun test.
 * App.tsx still owns setUserID + start() during boot.
 */
export const tracker = new Tracker({
  projectKey: 'Y2vdFj84wpO5auimdQSR',
  __DISABLE_SECURE_MODE: import.meta.env.VITE_ENV === 'local',
  network: {
    sessionTokenHeader: false,
    failuresOnly: false,
    ignoreHeaders: false,
    captureInIframes: true,
    capturePayload: true,
    sanitizer: (data) => {
      const isAdminPost =
        data.method?.toUpperCase() === 'POST' &&
        /\/api\/admin\/v1\/.*/.test(data.url);

      // Extra safety: redact Authorization if it somehow appears
      if (data.request?.headers) {
        for (const key of Object.keys(data.request.headers)) {
          if (key.toLowerCase() === 'authorization') {
            data.request.headers[key] = '<REDACTED>';
          }
        }
      }

      // Keep payload only for POST /api/admin/v1/*
      if (!isAdminPost) {
        if (data.request) data.request.body = null;
        if (data.response) data.response.body = null;
      }

      return data;
    },
  },
});
